import { Component, OnInit, EventEmitter, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Collana } from '../../../models/Collana';

@Component({
  selector: 'app-collana-selector',
  templateUrl: './collana-selector.component.html',
  styleUrls: ['./collana-selector.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CollanaSelectorComponent),
      multi: true
    }
  ]
})
export class CollanaSelectorComponent implements OnInit, ControlValueAccessor {
  collana: Collana;
  collana2string: string;
  step: number = 0;

  constructor() { }

  ngOnInit() {
  }

  private jsonString: string;
  private parseError: boolean;
  private data: any;
  // the method set in registerOnChange, it is just
  // a placeholder for a method that takes one parameter,
  // we use it to emit changes back to the form
  private propagateChange = (_: any) => { };
  // this is the initial value set to the component
  public writeValue(obj: Collana) {
    console.log('======= writeValue', obj)
    this.collana = obj;
    this.collana2string = this.collana ? this.collana.codice + ' - ' + this.collana.descrizione : '';
  }

  // registers 'fn' that will be fired when changes are made
  // this is how we emit the changes back to the form
  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
  // not used, used for touch input
  public registerOnTouched() { }

  // change events from the textarea
  private onChange(event) {
    console.log('onChange')
  }

  setStep(step: number) {
    this.step = step;
  }

  onNotify(collana: Collana): void {
    this.collana = collana;
    this.collana2string = collana ? collana.codice + ' - ' + collana.descrizione : '';
    this.setStep(0);
    this.propagateChange(this.collana);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/collana/collana-selector/collana-selector.component.ts